<template>
  <div class="vx-row">
    <div class="vx-col w-full flex flex-col">
      <vs-button
        @click="$router.push({name: 'users-create'})"
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        class="mb-4 self-end"
        size="medium"
      >Tambah Pengguna</vs-button>
      <vs-card>
        <div slot="header">
          <div class="vx-row m-2">
            <h3>Pengguna</h3>
          </div>
        </div>
        <div slot="header">
          <div class="vx-row flex flex-col m-0  w-full">
            <div class="flex w-full ">
              <div class="flex-1 p-2">
                <div class="w-full">
                  <vs-input icon-pack="feather" icon="icon-search" placeholder="Cari Nama Petugas"
                    v-model="filterSearch" class=" w-full" />
                </div>
              </div>
              <div class="w-full p-2  md:w-1/3">
                <v-select :options="listStatus" v-model="status" />
              </div>
              <div class="w-full p-2  md:w-1/3">
                <v-select :options="agencies" v-model="agencyId" />
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col">
          <vs-table :data="users">
            <template slot="thead">
              <vs-th>No.</vs-th>
              <vs-th>Nama Lengkap</vs-th>
              <vs-th>No. Telpon</vs-th>
              <vs-th>Role</vs-th>
              <vs-th>Status</vs-th>
              <vs-th>Action</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
                <vs-td :data="indextr">{{ indextr }}</vs-td>
                <vs-td :data="tr.name">{{ tr.name }}</vs-td>
                <vs-td :data="tr.phone">{{ tr.phone }}</vs-td>
                <vs-td :data="tr.phone">{{ tr.role }}</vs-td>
                <vs-td :data="tr.status">
                  <vs-chip
                    :color="tr.is_active ? 'green' : 'orange'"
                    class="product-order-status"
                  >{{tr.is_active ? 'Aktif' : 'Tidak Aktif'}}</vs-chip>
                  <vs-chip :color="'red'" v-if="tr.is_ban">Telah di Ban</vs-chip>
                </vs-td>
                <vs-td>
                  <div class="vx-row">
                    <vs-button
                      @click="$router.push({name: 'users-detail', params: {id: tr.id }})"
                      color="primary"
                      size="small"
                      class="m-1"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                    >Lihat</vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import _ from "lodash";

export default {
  data() {
    return {
      users: [],
      filterSearch : '',
      status: {
        value: 1,
        label: 'AKTIF'
      },
      agencyId: {
        value: "-",
        label: "SEMUA INSTANSI"
      },
      listStatus: [
        {
          value: 1,
          label: 'AKTIF'
        },
        {
          value: 0,
          label: 'TIDAK AKTIF'
        },
      ],
      agencies : []
    };
  },
  components: {
    "v-select": vSelect,
    Datepicker
  },
  mounted() {
    this.getData();
  },
  methods: {
    openAdd() {
      this.$router.push({ nama: "users-create" });
    },
    openDetail() {
      this.$router.push({ path: "users-detail" });
    },
    openEdit() {
      this.$router.push({ path: "users-edit" });
    },
    getData(){
      this.$vs.loading();
      this.$http
        .post("/app/secure/user/getData", {
          agency_id: this.agencyId.value,
          filter_search : this.filterSearch,
          status: this.status.value
        })
        .then(r => {
          this.users = r.data.data.users;
          this.agencies = r.data.data.agencies;
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    loadUsersData() {
      this.$vs.loading();
      this.$http
        .get("/app/secure/user")
        .then(r => {
          this.users = r.data.data.users;
        })
        .catch(e => {
          this.$vs.notify({
            title: "Error",
            text: e,
            color: "warning"
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    getRoleName(role) {
      let name = this.userRoles.find(item => {
        return item.id == role;
      });
      return name.label;
    }
  },
  watch: {
    filterSearch: _.debounce(function (query) {
      this.getData(query);
    }, 500),
    agencyId() {
      this.getData();
    },
    status() {
      this.getData();
    }
  },
  computed: {
    ...mapGetters(["userRoles"])
  }
};
</script>>

